import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { EtatCreance } from '../model/EtatCreance';

@Injectable({
  providedIn: "root"
})
export class EtatCreanceService {
  constructor(private _restClientService: RestClientService) {}

  getEtatCreanceListByNumDossier(numDossier) {
    return this._restClientService.load<EtatCreance[]>(
      "echeance/etat-creance-by-dossier?numDossier=" + numDossier
    );
  }
}
